import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { useDviLearningAlerts } from '@/hooks/useDviLearningAlerts';
import { formatDistanceToNow } from 'date-fns';

interface Props {
  shopId: string | null;
}

export function LearningEventTimeline({ shopId }: Props) {
  const { data: alerts = [], isLoading, isError } = useDviLearningAlerts(shopId);
  return (
    <Card>
      <CardHeader className="pb-2"><CardTitle className="text-sm">Learning Events</CardTitle></CardHeader>
      <CardContent>
        {isLoading && <div className="text-xs text-muted-foreground">Loading…</div>}
        {!isLoading && isError && (
          <div className="text-xs text-muted-foreground italic">Learning events are unavailable.</div>
        )}
        {!isLoading && !isError && alerts.length === 0 && (
          <div className="text-xs text-muted-foreground italic">No notable events in the last 14 days.</div>
        )}
        <div className="space-y-2 max-h-72 overflow-y-auto">
          {alerts.map((a, idx) => (
            <div key={idx} className="flex items-start gap-2 text-xs border-l-2 border-border pl-2 py-1">
              <Badge variant="outline" className={a.severity === 'high' ? 'bg-destructive/15 text-destructive border-destructive/30' : ''}>
                {a.event_type}
              </Badge>
              <div className="flex-1">
                <div className="text-foreground">{a.component} / {a.condition_type}</div>
                <div className="text-muted-foreground">{a.detail}</div>
                <div className="text-muted-foreground/70 text-[10px] mt-0.5">
                  {formatDistanceToNow(new Date(a.occurred_at), { addSuffix: true })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
